import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@shared/service/language/language.service';
import { LocalStorageService } from '@shared/service/local-storage/local-storage.service';
import {
  ButtonDirective,
  CardBodyComponent,
  CardComponent,
  InputGroupComponent,
  AlertComponent,
  SpinnerComponent,
  ContainerComponent,
  NavLinkDirective,
  NavComponent,
  FormSelectDirective,
  ProgressComponent,
  RowComponent,
  ColComponent,
  FormControlDirective,
} from '@coreui/angular-pro';
import { IconDirective } from '@coreui/icons-angular';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LoginComponent } from './component/login/login.component';
import { SharedModule } from '@shared/shared.module';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { ChangePasswordComponent } from './component/change-password/change-password.component';
import { LogoutComponent } from './component/logout/logout.component';
import { MfaComponent } from './component/mfa/mfa.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { TimeoutComponent } from './component/timeout/timeout.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CsToasterComponent } from '@shared/component/toster/toster.component';
import { MfaVerificationComponent } from '@shared/components/mfa-verification/mfa-verification.component';


@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    LogoutComponent,
    ForgotPasswordComponent,
    MfaComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    ButtonDirective,
    CardBodyComponent,
    CardComponent,
    IconDirective,
    InputGroupComponent,
    NgIf,
    TranslateModule,
    AlertComponent,
    SpinnerComponent,
    RouterLink,
    ContainerComponent,
    NavLinkDirective,
    NavComponent,
    FormSelectDirective,
    ProgressComponent,
    RowComponent,
    ColComponent,
    ReactiveFormsModule,
    FormControlDirective,
    CsToasterComponent,
    TimeoutComponent, // Standalone component imported here
    MfaVerificationComponent, // Shared MFA UI component
  ],
  exports: [
    LoginComponent,
    ResetPasswordComponent,
    LogoutComponent,
    ForgotPasswordComponent,
    TimeoutComponent, // Can still be exported from the module
  ],
  providers: [LanguageService, LocalStorageService],
})
export class AuthModule { }
